module.exports = __webpack_public_path__ + "static/media/tick-black.eb9e00b2.svg";